AppTabs.createTab( {
name: 'company-info',
icon: 'map-marked-alt',
text: 'Company Information',
create: function() {
    'use strict'

    return new TabControllerVue({
        el: '#vue-company-info',
        data: {
			name: null,
			address: null,
			city: null,
			state: null,
			zip: null,
			phone: null,
			fax: null,
			tollFree: null,
			established: null,
			fetching: true,
        },
        methods: {
			onShowTab() {
				const _this = this;
				window.ajaxCall({
					data : {
						action: 'get_company_info',
					},
					successMessage: 'Successfully Retrieved Company Information Settings',
					onSuccess: _this.setFromData,
				});
			},
			setFromData( { data } ) {
				this.fetching = true;
				this.name = data.name;
				this.address = data.address;
				this.city = data.city;
				this.state = data.state;
				this.zip = data.zip;
				this.phone = data.phone;
				this.fax = data.fax;
				this.tollFree = data.tollFree;
				this.established = data.established;
				setTimeout( () => this.fetching = false );
			},
			updateAddress() {
                const _this = this;
				window.ajaxCall({
					data: {
						action: 'update_company_info',
						company_info_data: {
							name:    _this.name,
							address: _this.address,
							city:    _this.city,
							state:   _this.state,
							zip:     _this.zip,
						},
					},
					successMessage: 'Successfully Updated Company Address',
					onSuccess: _this.setFromData,
				});
			},
			updatePhone() {
                const _this = this;
				window.ajaxCall({
					data: {
						action: 'update_company_info',
						company_info_data: { phone : _this.phone },
					},
					successMessage: 'Successfully Updated Company Phone Number',
					onSuccess: _this.setFromData,
				});
			},
			updateFax() {
                const _this = this;
				window.ajaxCall({
					data: {
						action: 'update_company_info',
						company_info_data: { fax : _this.fax },
					},
					successMessage: 'Successfully Updated Fax Number',
					onSuccess: _this.setFromData,
				});
			},
			updateTollFree() {
                const _this = this;
				window.ajaxCall({
					data: {
						action: 'update_company_info',
						company_info_data: { tollFree : _this.tollFree },
					},
					successMessage: 'Successfully Updated Toll Free Phone Number',
					onSuccess: _this.setFromData,
				});
			},
			updateEstablished() {
                const _this = this;
				window.ajaxCall({
					data: {
						action: 'update_company_info',
						company_info_data: { established : _this.established },
					},
					successMessage: 'Successfully Updated Year Established',
					onSuccess: _this.setFromData,
				});
			},
		},
		computed: {
			// Get a list of states for the address dropdowns...
            states: function() {
                return store.state.states;
			},
		},
		watch: {
			name:     function(value) { this.fetching || this.updateAddress() },
			address:  function(value) { this.fetching || this.updateAddress() },
			city:     function(value) { this.fetching || this.updateAddress() },
			state:    function(value) { this.fetching || this.updateAddress() },
			zip:      function(value) { this.fetching || this.updateAddress() },
			phone:    function(value) { this.fetching || this.updatePhone() },
			fax:      function(value) { this.fetching || this.updateFax() },
			tollFree: function(value) { this.fetching || this.updateTollFree() },
			established: function(value) { this.fetching || this.updateEstablished() },
		},
    });

}

} );
